// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"723":"38cfbff3","888":"46abe558"}[chunkId] + ".chunk.css";
};